export const baseUrl = 'https://celebri-backend.onrender.com'
// export const baseUrl = 'http://localhost:9000'